import { TaskListFilter } from "event-definitions"
import { Repeat } from "lib/@components/repeat"
import { PERIOD_SORT } from "library/SFG20/constants.mjs"
import { annualTiming, tasksNoHeaders } from "routes/schedule/plugins/task-summary/annual-timing"
import { getSelectables } from "routes/schedule/components/selectable/get-selectables"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTranslationContext } from "routes/schedule/plugins/translation/use-translation-context"
import { applyTaskListPayloadFilter } from "routes/regime/extension-edit/task-list-payload-filter"
import { useMemo } from "react"
import { ScheduleTimingPeriodGridItem } from "./schedule-timing-period-grid-item"

export { PeriodSummary, titleFromFrequency } from "./schedule-timing-period-summary"

TaskListFilter.handleOnce((info) => {
    const selected = getSelectables()
    if (!selected.period?.length) return
    const all = selected.period.map((filter) =>
        info.tasks.filter((task) => applyTaskListPayloadFilter(task, filter, info?.context?.payload?.tasks))
    )
    info.tasks = all.flat(1).unique()
})

export default function ScheduleTiming() {
    const { target } = useBoundContext()
    useTranslationContext()
    const allTasks = tasksNoHeaders(target.tasks)
    const totalTime = annualTiming(allTasks)
    const periods = Object.entries(
        allTasks.filter((t) => t.frequency).groupBy((task) => `${task.frequency.period}${task.frequency.interval}`)
    )
        .sortBy(([, list]) => {
            const task = list[0]
            return (PERIOD_SORT[task.frequency.period] ?? 0) * (task.frequency.interval || 1)
        })
        .map(1)

    const periodRows = useMemo(buildPeriodRows, [periods, totalTime])

    return <Repeat list={periodRows} item={<ScheduleTimingPeriodGridItem />} keyFn={periodRowKey} />

    function buildPeriodRows() {
        return periods.map((list) => ({
            list,
            listTime: annualTiming(list),
            totalTime,
        }))
    }
}

/**
 * @param {{ list: object[] }} row
 * @param {number} index
 */
function periodRowKey(row, index) {
    const f = row.list[0]?.frequency
    if (!f) return String(index)
    return `${f.period}-${f.interval}`
}
